import axiosInstance from "../axiosInstance";

const uid = localStorage.getItem("uid");   
export const getDashboardService = async () => {
    // const response = await axiosInstance.get('/portfolio/get-dashboard'); 
    const response = await axiosInstance.get(`/inv-portfolio/get-dashboard/${uid}`);    
    return response.data;
};
export const getAlerts = async () => {
    // const response = await axiosInstance.get('/portfolio/get-dashboard'); 
    const response = await axiosInstance.get(`/inv-portfolio/alerts/${uid}`);    
    return response.data;
};

export const createTimeline = async (payload) => {
    const response = await axiosInstance.post('/timelines', payload);
    return response.data;
};
